module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/user_two-77cff8a8e2bc211952454e2451494711.png";